import services from '@/config/services'

export default class DocumentationService {
  constructor(http, eventBus) {
    this.http = http
    this.eventBus = eventBus
    this.flussiUrl = `${services.ask_base_flussi.url}`
    this.praticheUrl = `${services.ask_pratiche_base.url}/api`
  }

  getDocumentationBaseUrl(project = 'ask_pratiche') {
    if (project === 'ask_pratiche') return this.praticheUrl + '/pratiche/v1/documentation'
    if (project === 'ask_flussi') return this.flussiUrl + '/documentation'
    if (project === 'ask_api') return services.ask_api.url + '/documentation'
    throw new Error('Progetto documentazione non valido')
  }

  async getDocumentationList(onProjectLoaded) {
    const projects = ['ask_pratiche', 'ask_flussi', 'ask_api']
    try {
      const results = await Promise.allSettled(projects.map(async project => {
        let result
        try {
          const response = await this.http.get(this.getDocumentationBaseUrl(project))
          if (!Array.isArray(response.data?.items)) throw new Error('Catalogo documentazione non valido')
          result = { project, items: response.data.items.map(document => ({ ...document, project })), unavailable: false }
        } catch {
          result = { project, items: [], unavailable: true }
        }
        if (onProjectLoaded) onProjectLoaded(result)
        return result
      }))
      const items = []
      const failed_projects = []
      results.forEach((result, index) => {
        const project = projects[index]
        if (result.status === 'fulfilled' && !result.value.unavailable) {
          items.push(...result.value.items)
        } else failed_projects.push(project)
      })
      return { items, failed_projects }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getDocumentation(filename, project = 'ask_pratiche') {
    try {
      const response = await this.http.get(this.getDocumentationBaseUrl(project) + '/' + encodeURIComponent(filename))
      return response.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

}
